//src/components/Think5WhysModuleCard.jsx
import React, { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useSwipeable } from 'react-swipeable';
import MainLayout from '../../layouts/MainLayout';
import '../../styles/Dashboard.css';
import DashboardGridData from '../../components/DashboardGridData';

import AboutImage from '../../assets/pageimages/About.webp';
import ApplauseHubImage from '../../assets/pageimages/ApplauseHub.webp';
import ARBookImage from '../../assets/pageimages/ARBook.webp';

import ArtFlowImage from '../../assets/pageimages/ArtFlow.webp';
import AssetTaggerImage from '../../assets/pageimages/AssetTagger.webp';
import AuthorDeskImage from '../../assets/pageimages/AuthorDesk.webp';

import BeSureImage from '../../assets/pageimages/BeSure.webp';
import BigDataImage from '../../assets/pageimages/BigData.webp';
import BookClubImage from '../../assets/pageimages/BookClub.webp';
import BookFusionImage from '../../assets/pageimages/BookFusion.webp';

import BookShelfImage from '../../assets/pageimages/BookShelf.webp';
import BookWorldImage from '../../assets/pageimages/BookWorld.webp';

import BpmForceImage from '../../assets/pageimages/BpmForce.webp';
import BreakingLiveImage from '../../assets/pageimages/BreakingLive.webp';

import CalcGeniusImage from '../../assets/pageimages/CalcGenius.webp';
import CandleScopeImage from '../../assets/pageimages/CandleScope.webp';
import ChaiWaiImage from '../../assets/pageimages/ChaiWai.webp';
import ChronoCheckImage from '../../assets/pageimages/ChronoCheck.webp';
import CoachingDiaryImage from '../../assets/pageimages/CoachingDiary.webp';
import CommuniCaptureImage from '../../assets/pageimages/CommuniCapture.webp';
import CoolEarthImage from '../../assets/pageimages/CoolEarth.webp';
import CorpConsoleImage from '../../assets/pageimages/CorpConsole.webp';

import CricSenseImage from '../../assets/pageimages/CricSense.webp';

import DashboardFillerImage from '../../assets/pageimages/DashboardFiller.webp';
import DictaBookImage from '../../assets/pageimages/DictaBook.webp';

import DigitalFranchiseImage from '../../assets/pageimages/DigitalFranchise.webp';

import DonaQRImage from '../../assets/pageimages/DonaQR.webp';
import EntryPassImage from '../../assets/pageimages/EntryPass.webp';
import EventFlowImage from '../../assets/pageimages/EventFlow.webp';
import ExhibitorsImage from '../../assets/pageimages/Exhibitors.webp';
import FeedbackCompassImage from '../../assets/pageimages/FeedbackCompass.webp';
import FiveWhysImage from '../../assets/pageimages/FiveWhys.webp';
import FlipBookImage from '../../assets/pageimages/FlipBook.webp';

import FocusTimerImage from '../../assets/pageimages/FocusTimer.webp';

import GameOnImage from '../../assets/pageimages/GameOn.webp';
import GiftItImage from '../../assets/pageimages/GiftIt.webp';
import GovZoneImage from '../../assets/pageimages/GovZone.webp';
import GroupStudyImage from '../../assets/pageimages/GroupStudy.webp';

import InfoGraphicsImage from '../../assets/pageimages/InfoGraphics.webp';

import IntegraImage from '../../assets/pageimages/Integra.webp';
import ISO360Image from '../../assets/pageimages/ISO360.webp';
import JobJournalImage from '../../assets/pageimages/JobJournal.webp';
import JobWorksImage from '../../assets/pageimages/JobsWorks.webp';
import JourneyJoyImage from '../../assets/pageimages/JourneyJoy.webp';
import LeadPulseImage from '../../assets/pageimages/LeadPulse.webp';
import LearningImage from '../../assets/pageimages/Learning.webp';
import LifeChronicleImage from '../../assets/pageimages/LifeChronicle.webp';
import LifeResourcesImage from '../../assets/pageimages/LifeResources.webp';
import ManifestoImage from '../../assets/pageimages/Manifesto.webp';
import MADSmaniaImage from '../../assets/pageimages/MADSmania.webp';

import MealMarchImage from '../../assets/pageimages/MealMarch.webp';
import MyDiaryImage from '../../assets/pageimages/MyDiary.webp';
import MyJerseyImage from '../../assets/pageimages/MyJersey.webp';

import MyJournalImage from '../../assets/pageimages/MyJournal.webp';
import MyKaizenImage from '../../assets/pageimages/MyKaizen.webp';

import NothingSecretImage from '../../assets/pageimages/NothingSecret.webp';
import OrderFlowImage from '../../assets/pageimages/OrderFlow.webp';
import PacketPulseImage from '../../assets/pageimages/PacketPulse.webp';
import PayCheckImage from '../../assets/pageimages/PayCheck.webp';
import PovifyImage from '../../assets/pageimages/Povify.webp';
import ProcessifydImage from '../../assets/pageimages/Processifyd.webp';
import PurplePowerImage from '../../assets/pageimages/PurplePower.webp'
import ProfileImage from '../../assets/pageimages/Profile.webp';
import QuizCornerImage from '../../assets/pageimages/QuizCorner.webp';

import RMSImage from '../../assets/pageimages/RMS.webp';
import SacredQImage from '../../assets/pageimages/SacredQ.webp';
import SanatanImage from '../../assets/pageimages/Sanatan.webp';
import ScanAnytimeImage from '../../assets/pageimages/ScanAnytime.webp';
import SelfStudyImage from '../../assets/pageimages/SelfStudy.webp';
import SevenWondersImage from '../../assets/pageimages/SevenWonders.webp';

import SigmaStudioImage from '../../assets/pageimages/SigmaStudio.webp';
import SmartDrillImage from '../../assets/pageimages/SmartDrill.webp';

import SpotSnapImage from '../../assets/pageimages/SpotSnap.webp';
import SprintCentralImage from '../../assets/pageimages/SprintCentral.webp';
import TableTalesImage from '../../assets/pageimages/TableTales.webp';
import TestBookImage from '../../assets/pageimages/TestBook.webp';
import TouchBookImage from '../../assets/pageimages/TouchBook.webp';
import TVBookImage from '../../assets/pageimages/TVBook.webp';
import VideoBookImage from '../../assets/pageimages/VideoBook.webp';

import VideoReviewImage from '../../assets/pageimages/VideoReview.webp';

import VisiGiftImage from '../../assets/pageimages/VisiGift.webp';
import VisualBriefImage from '../../assets/pageimages/VisualBrief.webp';

import WaitWellImage from '../../assets/pageimages/WaitWell.webp';
import WalkingJoyImage from '../../assets/pageimages/WalkingJoy.webp';
import WalletImage from '../../assets/pageimages/Wallet.webp';

import WhatsupImage from '../../assets/pageimages/Whatsup.webp';
import WelcomeImage from '../../assets/pageimages/Welcome.webp';
import WheelsWatchImage from '../../assets/pageimages/WheelsWatch.webp';

const imageMap = {
  'AboutImage': AboutImage,
  'ApplauseHubImage': ApplauseHubImage,
  'ArtFlowImage': ArtFlowImage,
  'ARBookImage': ARBookImage,
  'AssetTaggerImage': AssetTaggerImage,
  'AuthorDeskImage': AuthorDeskImage,
  'BeSureImage': BeSureImage,
  'BigDataImage': BigDataImage,
  'BookClubImage': BookClubImage,
  'BookFusionImage': BookFusionImage,
  'BookShelfImage': BookShelfImage,
  'BookWorldImage': BookWorldImage,
  'BpmForceImage': BpmForceImage,
  'BreakingLiveImage': BreakingLiveImage,
  'CalcGeniusImage': CalcGeniusImage,
  'CandleScopeImage': CandleScopeImage,
  'ChaiWaiImage': ChaiWaiImage,
  'ChronoCheckImage': ChronoCheckImage,
  'CoachingDiaryImage': CoachingDiaryImage,
  'CommuniCaptureImage': CommuniCaptureImage,
  'CoolEarthImage': CoolEarthImage,
  'CorpConsoleImage': CorpConsoleImage,
  'CricSenseImage': CricSenseImage,
  'DashboardFillerImage': DashboardFillerImage,
  'DictaBookImage': DictaBookImage,
  'DigitalFranchiseImage': DigitalFranchiseImage,
  'DonaQRImage': DonaQRImage,
  'EntryPassImage': EntryPassImage,
  'EventFlowImage': EventFlowImage,
  'ExhibitorsImage': ExhibitorsImage,
  'FeedbackCompassImage': FeedbackCompassImage,
  'FiveWhysImage': FiveWhysImage,
  'FlipBookImage': FlipBookImage,
  'FocusTimerImage': FocusTimerImage,
  'GameOnImage': GameOnImage,
  'GiftItImage': GiftItImage,
  'GovZoneImage': GovZoneImage,
  'GroupStudyImage': GroupStudyImage,
  'InfoGraphicsImage': InfoGraphicsImage,
  'IntegraImage': IntegraImage,
  'ISO360Image': ISO360Image,
  'JobJournalImage': JobJournalImage,
  'JobWorksImage': JobWorksImage,
  'JourneyJoyImage': JourneyJoyImage,
  'LeadPulseImage': LeadPulseImage,
  'LearningImage': LearningImage,
  'LifeChronicleImage': LifeChronicleImage,
  'LifeResourcesImage': LifeResourcesImage,
  'ManifestoImage': ManifestoImage,
  'MADSmaniaImage': MADSmaniaImage,
  'MealMarchImage': MealMarchImage,
  'MyDiaryImage': MyDiaryImage,
  'MyJerseyImage': MyJerseyImage,
  'MyJournalImage': MyJournalImage,
  'MyKaizenImage': MyKaizenImage,
  'NothingSecretImage': NothingSecretImage,
  'OrderFlowImage': OrderFlowImage,
  'PacketPulseImage': PacketPulseImage,
  'PayCheckImage': PayCheckImage,
  'PovifyImage': PovifyImage,
  'ProcessifydImage': ProcessifydImage,
  'PurplePowerImage': PurplePowerImage,
  'ProfileImage': ProfileImage,
  'QuizCornerImage': QuizCornerImage,
  'RMSImage': RMSImage,
  'SacredQImage': SacredQImage,
  'SanatanImage': SanatanImage,
  'ScanAnytimeImage': ScanAnytimeImage,
  'SelfStudyImage': SelfStudyImage,
  "SevenWondersImage": SevenWondersImage,
  'SigmaStudioImage': SigmaStudioImage,
  "SmartDrillImage": SmartDrillImage,
  'SpotSnapImage': SpotSnapImage,
  'SprintCentralImage': SprintCentralImage,
  'TableTalesImage': TableTalesImage,
  'TestBookImage': TestBookImage,
  'TouchBookImage': TouchBookImage,
  'TVBookImage': TVBookImage,
  'VideoBookImage': VideoBookImage,
  'VideoReviewImage': VideoReviewImage,
  'VisiGiftImage': VisiGiftImage,
  'VisualBriefImage': VisualBriefImage,
  'WaitWellImage': WaitWellImage,
  'WalkingJoyImage': WalkingJoyImage,
  'WalletImage': WalletImage,
  'WhatsupImage': WhatsupImage,
  'WelcomeImage': WelcomeImage,
  'WheelsWatchImage': WheelsWatchImage,
};


const Think5WhysModuleCard = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData, { loading }] = useFetch();
  const [currentModuleIndex, setCurrentModuleIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [modules, setModules] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  //ModuleList
  const fetchModuleList = useCallback(() => {
    const config = {
      url: "/modules",
      method: "get",
      headers: { Authorization: authState.token }
    };

    fetchData(config, { showSuccessToast: false })
      .then(response => {
        // console.log("Module List Response:", response);
        if (Array.isArray(response)) {
          setModules(response);
        } else {
          console.error("Invalid response format: Module list not found in response");
        }
      })
      .catch(error => {
        console.error("Error fetching practice list:", error);
      });
  }, [authState.token, fetchData]);

  useEffect(() => {
    fetchModuleList();
  }, [fetchModuleList]);


  const handleNext = () => {
    setCurrentModuleIndex((prevIndex) => (prevIndex + 1) % modules.length);
  };

  const handlePrevious = () => {
    setCurrentModuleIndex((prevIndex) => (prevIndex - 1 + modules.length) % modules.length);
  };

  const handlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrevious,
  });

  const currentModule = modules[currentModuleIndex];

  if (!currentModule) {
    return null; // or display a loading indicator
  }

  const moduleImage = imageMap[currentModule.moduleBanner];

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <div className="dashboard-header">
          <h3 style={{ color: 'white' }}>Think5Whys Modules Card</h3>
        </div>
      </div>
      <div className="my-2 mx-auto max-w-[700px] py-4">
        <div {...handlers} className="module" style={{ textAlign: 'center', margin: '15px' }}>
          <p className='text-xl text-white mb-4'>{currentModuleIndex + 1}</p>
          {/* {currentModule.moduleBanner} */}
          <img src={moduleImage} alt={currentModule.moduleTitle} style={{ marginBottom: '10px', margin: 'auto' }} />
          <div className="module-title text-xl bg-purple-800 text-yellow-300 mt-4">
            {currentModule.moduleTitle}
          </div>
          <div className="module-title text-white" style={{ color: 'white' }}>
            {currentModule.moduleDesc}
          </div>
          <div className="module-details mt-4">
            <p className="mt-4 bg-slate-700 text-yellow-300">Who: {currentModule.moduleWho}</p>
            <p className="mt-4 bg-green-800 text-white">What: {currentModule.moduleWhat}</p>
            <p className="mt-4 bg-slate-700 text-yellow-300">Why: {currentModule.moduleWhy}</p>
            <p className="mt-4 bg-green-800 text-white">When: {currentModule.moduleWhen}</p>
            <p className="mt-4 bg-slate-700 text-yellow-300">Where: {currentModule.moduleWhere}</p>
            <p className="mt-4 bg-green-800 text-white">How: {currentModule.moduleHow}</p>
            {/* <p className="mt-4 bg-slate-700 text-yellow-300">dangerouslySetInnerHTML={{ __html: `Remarks: ${currentModule.moduleRemarks}` }}</p> */}
            <div className="mt-4 bg-slate-700 text-white" dangerouslySetInnerHTML={{ __html: `Remarks: ${currentModule.moduleRemarks}` }}></div>
          </div>
        </div>
        {!isMobile && (
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <button onClick={handlePrevious} style={{ marginRight: '10px' }}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>
            <button onClick={handleNext}>
              <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </div>
        )}
      </div>
    </MainLayout>
  );
}

export default Think5WhysModuleCard;




